import { motion } from "framer-motion";
import PageTemplate from "../../components/layout/PageTemplate";
import { FanMVPListWidget } from "../../widgets/fan-mvp";
import { getStaticUrl, setDocumentTitle } from "../../utils";
import { useEffect } from "react";

const FanMVPListPage = () => {
    useEffect(() => {
        setDocumentTitle(`Лучшие игроки по мнению болельщиков - Официальный сайт ФК «Родина»`);
    }, [])
    return (
        <PageTemplate bgImageUrl={getStaticUrl('/uploads/c9ac507b3603702af02ebe0a99537d03.png')} className="bg-[url(https://fcrodina.com/uploads/c9ac507b3603702af02ebe0a99537d03.png)]">
            <div className="min-h-64 sm:min-h-96 max-h-screen flex flex-col items-center justify-center gap-8 p-2 sm:p-0 sm:pt-8 max-w-4xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: -50 }} // Начальное состояние (невидимо и смещено вниз)
                    animate={{ opacity: 1, y: 0 }}  // Конечное состояние (видимо и на месте)
                    transition={{ duration: 0.5 }}  // Длительность анимации
                    className="text-3xl sm:text-7xl font-bold italic text-white"
                >
                    Лучшие игроки <br /> по версии болельщиков
                </motion.div>
            </div>
            <div className="w-full mx-auto text-white text-2xl text-center p-2 sm:p-0 sm:pb-16">
                <FanMVPListWidget />
            </div>
        </PageTemplate>
    )
}

export default FanMVPListPage;